import { render, staticRenderFns } from "./SellerConfig.vue?vue&type=template&id=031db920&scoped=true&"
import script from "./SellerConfig.vue?vue&type=script&lang=js&"
export * from "./SellerConfig.vue?vue&type=script&lang=js&"
import style0 from "./SellerConfig.vue?vue&type=style&index=0&id=031db920&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031db920",
  null
  
)

export default component.exports